export const html = document.documentElement;
export const body = document.body;
export const mode = window.innerWidth >= 750 ? true : false;
export const tdev = (window.ontouchstart === null) ? true : false;
export const headerH = window.innerWidth >= 750 ? 128 : 64;
